import {
  AbstractControl,
  AbstractControlOptions,
  AsyncValidatorFn,
  UntypedFormControl,
  UntypedFormGroup,
  ValidatorFn,
} from '@angular/forms'

// TODO: get rid of this file and use the typed FormGroup/FormControl from angular directly

/** @deprecated use Angular typed FormControl, FormGroup and FormArray */
export type FormControls = Record<string, AbstractControl>

/** @deprecated use Angular typed FormControl, FormGroup and FormArray */
export type TypedFormControls<T> = Record<keyof T, AbstractControl>

/** @deprecated use Angular typed FormControl, FormGroup and FormArray */
export class TypedFormGroup<T> extends UntypedFormGroup {
  constructor(
    controls: {
      [key in keyof T]: AbstractControl
    },
    validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null,
    asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null,
  ) {
    super(controls, validatorOrOpts, asyncValidator)
  }

  declare value: T
  declare controls: TypedFormControls<T>
}

/** @deprecated use Angular typed FormControl, FormGroup and FormArray */
export class TypedFormControl<T> extends UntypedFormControl {
  constructor(
    formState?: T,
    validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null,
    asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null,
  ) {
    super(formState, validatorOrOpts, asyncValidator)
  }

  declare value: T

  setValue(value: T) {
    super.setValue(value)
  }
}
